import { render, staticRenderFns } from "./Turnover.vue?vue&type=template&id=38795956&scoped=true&"
import script from "./Turnover.vue?vue&type=script&lang=ts&"
export * from "./Turnover.vue?vue&type=script&lang=ts&"
import style0 from "./Turnover.vue?vue&type=style&index=0&id=38795956&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38795956",
  null
  
)

export default component.exports